var _linearGradient, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    width: "1em",
    height: "1em",
    fill: "none",
    xmlns: "https://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_331_3038",
    x1: 12.0934,
    y1: 3.39348,
    x2: 12.7172,
    y2: 10.3358,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(1.199934, 0, 0, 1.199934, -0.999654, -0.399447)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D869FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7569FF"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    gradientUnits: "userSpaceOnUse",
    x1: 5.833,
    y1: 0.958,
    x2: 5.833,
    y2: 13.042,
    id: "gradient-0",
    gradientTransform: "matrix(1.199934, 0, 0, 1.199934, -0.999654, -0.399447)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgba(190, 105, 255, 1)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgba(146, 3, 255, 1)"
    }
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 11.75 4.751 L 15.25 8 L 11.75 11.249 M 14.999 8 L 6.75 8",
    stroke: "url(#paint0_linear_331_3038)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M 11.249 0.75 L 2.75 0.75 C 1.64 0.75 0.75 1.64 0.75 2.75 L 0.75 13.25 C 0.75 14.35 1.64 15.25 2.75 15.25 L 11.249 15.25",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    style: {
      stroke: "url(#gradient-0)"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.9f2455de2336bccc38f22fc5bcff0ff2.svg";
export { ForwardRef as ReactComponent };